import Crud from '../views/Finalizacao/Crud'
import Entity from '../views/Finalizacao/Add'
import View from '../views/Finalizacao/View'

let routes = {
    path: '/finalizacoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/finalizacoes/add',
            name: 'Newfinalizacao',
            component: Entity,
            meta: {
                pageTitle: 'Criação Finalizações',
                breadcrumb: [
                    {
                        text: 'Finalizações',
                        active: false,
                        to: '/finalizacoes',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/finalizacoes/edit/:id?',
            name: 'Editfinalizacao',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Finalizações',
                breadcrumb: [
                    {
                        text: 'Finalizações',
                        active: false,
                        to: '/finalizacoes',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/finalizacoes/view/:id?',
            name: 'Viewfinalizacao',
            component: View,
            meta: {
                pageTitle: 'Visualizar Finalizações',
                breadcrumb: [
                    {
                        text: 'Finalizações',
                        active: false,
                        to: '/finalizacoes',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/finalizacoes',
            name: 'list-finalizacoes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Finalizações',
                breadcrumb: [
                    {
                        text: 'Finalizações',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
